module.exports = __webpack_public_path__ + "img/004.c9e58d58.png";